// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const browserLanguage = navigator.language || navigator.userLanguage;
console.log("浏览器的默认语言是:", browserLanguage);
const language = browserLanguage.startsWith('zh') ? 'zh' : 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        // Navbar translations
        "welcome": "Welcome to our website",
        "new_campaign": "New Campaign",
        "account": "Account",
        "update_account": "Update Account",
        "recharge_credits": "Recharge Credits",
        "login": "Login",
        "balance": "Balance: {{balance}} credits",
        "confirm_logout": "Confirm Logout",
        "logout_prompt": "Are you sure you want to log out?",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "logout": "Logout",

        // Footer translations
        "Resources": "Resources",
        "Legal": "Legal",
        "Contact_Support": "Contact Support",
        "Refund_Policy": "Refund Policy",
        "Privacy_Policy": "Privacy Policy",
        "Terms_of_Use": "Terms of Use",

        // Contact Support translations
        "contact_support": "Contact Support",
        "contact_support_description": "Need help? Our support team is here to assist you. Please feel free to reach out to us through the following channels.",
        "email_support": "Email Support",
        "email_support_description": "For any questions or concerns, please email us at:",
        "response_time": "Response Time",
        "response_time_description": "We typically respond within 24 hours during business days.",
        "additional_info": "Additional Information",
        "additional_info_description": "For faster assistance, please include your account email and any relevant details in your message.",

        // Home page translations
        "welcome_to_janney_ai": "Welcome to Janney AI",
        "welcome_new_user": "Register as a new user and get 500 points instantly. Recommend to friends and get more points.",
        "janney_ai_description": "Janney AI helps you detect AIGC content and rewrite articles to minimize the risk of AIGC detection. Our advanced tools ensure your content remains unique, secure, and human-like.",
        "free_trial": "Free Trial",

        // Recharge page translations
        "recharge": "Recharge",
        "recharge_description": "Choose a package to recharge your credits",
        "credit_card": "Credit Card",
        "paypal": "PayPal",
        "apple_pay": "Apple Pay",
        "google_pay": "Google Pay",
        "alipay": "Alipay",
        "wechat_pay": "WeChat Pay",
        "select_currency": "Select Currency",
        "currency_cny": "Chinese Yuan (CNY)",
        "currency_usd": "US Dollar (USD)",
        "currency_cad": "Canadian Dollar (CAD)",
        "most_popular": "Most Popular",
        "credits": "Credits",
        "select_package": "Select Package",
        "not_logged_in": "Not Logged In",
        "login_prompt_recharge": "Please log in to recharge credits",
        "back_home": "Back to Home",

        // Payment result translations
        "payment_result": "Payment Result",
        "missing_payment_intent": "Missing payment information",
        "payment_failed": "Payment failed",
        "loading": "Loading...",
        "confirming_order": "Confirming your order...",
        "try_again": "Try Again",
        "payment_success": "Payment Successful",
        "payment_amount": "Payment Amount",
        "payment_time": "Payment Time",
        "continue_recharge": "Continue Recharge",
        "start_using": "Start Using",
        "unknown_error": "An unknown error occurred",

        // Account management translations
        "username": "Username",
        "email": "Email",
        "password": "Password",
        "confirm_password": "Confirm Password",
        "change_password": "Change Password",
        "update": "Update",
        "delete_account": "Delete Account",
        "confirm_delete_account": "Confirm Account Deletion",
        "enter_email_to_confirm": "Enter your email to confirm deletion",
        "email_mismatch": "Email does not match",
        "account_delete_success": "Account deleted successfully",
        "account_delete_failed": "Failed to delete account",
        "username_update_success": "Username updated successfully",
        "username_update_failed": "Failed to update username",
        "login_required": "Login Required",
        "login_required_message": "Please log in to access this feature",
        "account_settings": "Account Settings",
        "cancel": "Cancel",
        "back_home": "Back to Home",
        "new_password": "New Password",
        "verification_failed": "Verification code sending failed",
        "invalid_code": "Invalid verification code",
        "password_changed_success": "Password changed successfully",
        "password_change_failed": "Password change failed",
        "email_not_registered": "This email is not registered",
        "send_verification_code": "Send Verification Code",
        "resend_code": "Resend Verification Code",
        "seconds": "Seconds",
        "verification_prompt": "Please enter the verification code sent to your email",
        "enter_verification_code": "Enter Verification Code",
        "verify": "Verify",

        // Registration translations
        "register": "Register",
        "email_already_registered": "Email is already registered",
        "try_later": "Please try again later",
        "verification_code_sent": "Verification code has been sent",
        "verification_code_failed": "Failed to send verification code",
        "invalid_email": "Invalid email address",
        "password_mismatch": "Passwords do not match",
        "fill_all_fields": "Please fill in all fields",
        "username_not_digits": "Username cannot contain only digits",
        "register_success": "Registration successful",
        "register_failed": "Registration failed",
        "already_have_account": "Already have an account",
        "click_here_login": "Click here to login",
        "email_verification": "Email Verification",
        "close": "Close",

        // Login translations
        "google_login_page_loading_error": "Error loading Google login page",
        "user_info": "User Information",
        "balance_info": "Balance Information",
        "login_success": "Login successful",
        "login_failed": "Login failed",
        "user_email_not_exist": "Email does not exist",
        "login_response": "Login Response",
        "login_access_info": "Interested in using Janney AI? Please book a demo on our official website (www.janney.ai) to get access.",

        // Error messages
        "sensitive_word_warning": "Warning: Sensitive content detected",
        "request_error": "Request failed"
      }
    },
    zh: {
      translation: {
        // Navbar translations
        "welcome": "欢迎来到我们的网站",
        "new_campaign": "新建活动",
        "account": "账户",
        "update_account": "更新账户",
        "recharge_credits": "充值积分",
        "login": "登录",
        "balance": "余额：{{balance}} 积分",
        "confirm_logout": "确认退出登录",
        "logout_prompt": "你确定要退出登录吗？",
        "cancel": "取消",
        "confirm": "确认",
        "logout": "退出登录",

        // Footer translations
        "Resources": "资源",
        "Legal": "法律条款",
        "Contact_Support": "联系客服",
        "Refund_Policy": "退款政策",
        "Privacy_Policy": "隐私政策",
        "Terms_of_Use": "使用条款",

        // Contact Support translations
        "contact_support": "联系客服",
        "contact_support_description": "需要帮助？我们的支持团队随时为您服务。请通过以下方式与我们联系。",
        "email_support": "邮件支持",
        "email_support_description": "如有任何问题或疑虑，请发送邮件至：",
        "response_time": "响应时间",
        "response_time_description": "我们通常会在工作日24小时内回复。",
        "additional_info": "其他信息",
        "additional_info_description": "为了更快获得帮助，请在消息中包含您的账户邮箱和相关详细信息。",

        // Home page translations
        "welcome_to_janney_ai": "欢迎来到 Janney AI",
        "welcome_new_user": "新用户注册，立得500积分，推荐给朋友立享更多积分。",
        "janney_ai_description": "Janney AI 帮助您检测 AIGC，并重写文章以降低 AIGC率。我们的高级工具确保您的内容独特、安全且更具人性化。",
        "free_trial": "免费试用",

        // Recharge page translations
        "recharge": "充值",
        "recharge_description": "选择套餐充值积分",
        "credit_card": "信用卡",
        "paypal": "PayPal",
        "apple_pay": "Apple Pay",
        "google_pay": "Google Pay",
        "alipay": "支付宝",
        "wechat_pay": "微信支付",
        "select_currency": "选择货币",
        "currency_cny": "人民币 (CNY)",
        "currency_usd": "美元 (USD)",
        "currency_cad": "加拿大元 (CAD)",
        "most_popular": "最受欢迎",
        "credits": "积分",
        "select_package": "选择套餐",
        "not_logged_in": "未登录",
        "login_prompt_recharge": "请登录后进行充值",
        "back_home": "返回首页",

        // Payment result translations
        "payment_result": "支付结果",
        "missing_payment_intent": "缺少支付信息",
        "payment_failed": "支付失败",
        "loading": "加载中...",
        "confirming_order": "正在确认订单...",
        "try_again": "重试",
        "payment_success": "支付成功",
        "payment_amount": "支付金额",
        "payment_time": "支付时间",
        "continue_recharge": "继续充值",
        "start_using": "开始使用",
        "unknown_error": "发生未知错误",

        // Account management translations
        "username": "用户名",
        "email": "邮箱",
        "password": "密码",
        "confirm_password": "确认密码",
        "change_password": "修改密码",
        "update": "更新",
        "delete_account": "删除账户",
        "confirm_delete_account": "确认删除账户",
        "enter_email_to_confirm": "输入邮箱以确认删除",
        "email_mismatch": "邮箱不匹配",
        "account_delete_success": "账户已成功删除",
        "account_delete_failed": "删除账户失败",
        "username_update_success": "用户名更新成功",
        "username_update_failed": "用户名更新失败",
        "login_required": "需要登录",
        "login_required_message": "请登录后访问此功能",
        "account_settings": "账户设置",
        "cancel": "取消",
        "back_home": "返回首页",
        "new_password": "新密码",
        "verification_failed": "验证码发送失败",
        "invalid_code": "验证码无效",
        "password_changed_success": "密码修改成功",
        "password_change_failed": "密码修改失败",
        "email_not_registered": "该邮箱未注册",
        "send_verification_code": "发送验证码",
        "resend_code": "重新发送验证码",
        "seconds": "秒",
        "verification_prompt": "请输入发送到您邮箱的验证码",
        "enter_verification_code": "输入验证码",
        "verify": "验证",

        // Registration translations
        "register": "注册",
        "email_already_registered": "邮箱已被注册",
        "try_later": "请稍后重试",
        "verification_code_sent": "验证码已发送",
        "verification_code_failed": "验证码发送失败",
        "invalid_email": "无效的邮箱地址",
        "password_mismatch": "密码不匹配",
        "fill_all_fields": "请填写所有字段",
        "username_not_digits": "用户名不能只包含数字",
        "register_success": "注册成功",
        "register_failed": "注册失败",
        "already_have_account": "已有账户",
        "click_here_login": "点击此处登录",
        "email_verification": "邮箱验证",
        "close": "关闭",

        // Login translations
        "google_login_page_loading_error": "加载Google登录页面失败",
        "user_info": "用户信息",
        "balance_info": "余额信息",
        "login_success": "登录成功",
        "login_failed": "登录失败",
        "user_email_not_exist": "邮箱不存在",
        "login_response": "登录响应",
        "login_access_info": "如需使用Janney AI，请前往官网（www.janney.ai）预约演示以获取访问权限。",

        // Error messages
        "sensitive_word_warning": "警告：检测到敏感内容",
        "request_error": "请求失败"
      }
    }
  },
  lng: language,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
